import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NavigationModel } from "../../../../../model/finzy-flex/finzy-flex-config.model";
import { FfEndPoints } from "../../ff-endpoints";

@Component({
    selector: 'app-flex-menu',
    templateUrl: './flex-menu.component.html',
    styleUrls: ['./flex-menu.component.css']
})
export class FlexMenuComponent {
    private readonly router: Router;

    public readonly dashboardNav = `/${FfEndPoints.DASHBOARD}`;
    public readonly loansNav = `/${FfEndPoints.LOANS}`;
    public readonly preferencesNav = `/${FfEndPoints.PREFERENCES}`;
    public readonly reportsNav = `/${FfEndPoints.REPORTS}`;
    public readonly interestCertificateNav =`/${FfEndPoints.INTERESTCERTIFICATE}`;
    public navigationMenu: NavigationModel[] = [
        {
            navPath: this.dashboardNav,
            iconActivePath: '../../../../../../assets/images/finzy-flex/dashboard-active.svg',
            iconInActivePath: '../../../../../../assets/images/finzy-flex/dashboard-inactive.svg',
            menuName: 'Dashboard',
        },
        {
            navPath: this.loansNav,
            iconActivePath: '../../../../../../assets/images/finzy-flex/loans-active.svg',
            iconInActivePath: '../../../../../../assets/images/finzy-flex/loans-inactive.svg',
            menuName: 'Loans',
        },
        {
            navPath: this.preferencesNav,
            iconActivePath: '../../../../../../assets/images/finzy-flex/preferences-active.svg',
            iconInActivePath: '../../../../../../assets/images/finzy-flex/preferences-inactive.svg',
            menuName: 'Preferences',
        },
        {
            navPath: this.reportsNav,
            iconActivePath: '../../../../../../assets/images/finzy-flex/reports-active.svg',
            iconInActivePath: '../../../../../../assets/images/finzy-flex/reports-inactive.svg',
            menuName: 'Reports',
        },
        {
            navPath: this.interestCertificateNav,
            iconActivePath: '../../../../../../assets/images/finzy-flex/interest-certificate-active.svg',
            iconInActivePath: '../../../../../../assets/images/finzy-flex/interest-certificate-inactive.svg',
            menuName: 'Interest Certificate',
            navMenuId: 'interestCertificate'
        },
    ];
    constructor(
        router: Router,
    ) {
        this.router = router;
    }

    public checkRouterIsActive(navPath: string): boolean {
        return this.router.isActive(navPath, true);
    }
}